module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fb-Ga-Hc-Id-Ja.8a0bbebc.png";